import { render, staticRenderFns } from "./search_page.vue?vue&type=template&id=ada83aa2"
import script from "./search_page.js?vue&type=script&lang=js&external"
export * from "./search_page.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports